/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, shape, string, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactMarkdown from 'react-markdown';
import Grid from '@material-ui/core/Grid';
import Accordion from '@material-ui/core/ExpansionPanel';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import AccordionDetails from '@material-ui/core/ExpansionPanelDetails';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';

const styles = (theme)  => ({
    headerBlock: {
        top: '0',
        width: '100%',
        margin: '0 auto',
        padding: '0px 7px',
        position: 'absolute',
        textAlign: 'center',
        whiteSpace: 'break-spaces',
        bottom: '0',
        right: '0',
        left: '0',
        display: 'flex',
        alignItems: 'center',
        lineHeight: 0.9,
    },
    imocBanner: {
        position: 'relative',
        display: 'block',
    },
    heroMainImage: {
        width: '100%',
        display: 'block',
    },
    heading: {
        fontWeight: 700,
        lineHeight: '1.2',
        '& h1': {
            margin: 0,
            fontSize: 28,
            '& strong': {
                color: theme.palette.cms?.subHeadercolor  || '#fe948c',
            },
        },
        '& h3': {
            overflow: 'hidden',
            margin: '5px 0px',
            color: theme.palette.cms?.subHeadercolor || '#fe948c',
            '&::before': {
                width: '15%',
                right: '0.5em',
                height: '1px',
                content: '""',
                display: 'inline-block',
                position: 'relative',
                verticalAlign: 'middle',
                backgroundColor: theme.palette.cms?.subHeadercolor || '#fe948c',
            },
            '&::after': {
                left: '.5em',
                width: '15%',
                height: '1px',
                content: '""',
                display: 'inline-block',
                position: 'relative',
                verticalAlign: 'middle',
                backgroundColor: theme.palette.cms?.subHeadercolor || '#fe948c',
            },
        },
        '& h2': {
            margin: 0,
            fontSize: '18px',
            color: theme.palette.cms?.subHeadercolor || '#fe948c',
        },
        '& p': {
            fontSize: '18px',
            margin: '0',
        },
    },
    subHeading: {
        '& p': {
            fontSize: 18,
            margin: '10px auto',
            lineHeight: '1.4',
            width: 350,
        },
        '& h2': {
            margin: 0,
            fontSize: 18,
            overflow: 'hidden',
            '&::before': {
                width: '15%',
                right: '0.5em',
                height: '1px',
                content: '""',
                display: 'inline-block',
                position: 'relative',
                verticalAlign: 'middle',
                backgroundColor: theme.palette.cms?.black || '#000000',
            },
            '&::after': {
                left: '.5em',
                width: '15%',
                height: '1px',
                content: '""',
                display: 'inline-block',
                position: 'relative',
                verticalAlign: 'middle',
                backgroundColor: theme.palette.cms?.black || '#000000',
            },
        },
    },
    shopButton: {
        padding: '10px 30px',
        display: 'inline-block',
        fontSize: 14,
        fontWeight: 'bold',
        letterSpacing: '1.2px',
        textTransform: 'uppercase',
        textDecoration: 'none',
    },
    listBlock: {
        width: '100%',
        '& a': {
            textDecoration: 'none',
            display: 'block',
        },
        '& ul': {
            padding: 0,
            margin: 0,
        },
        '& li': {
            listStyle: 'none',
            borderTop: '1px solid',
            textAlign: 'center',
            padding: '4px 0px',
            fontWeight: '600',
            fontSize: '16px',
        },
    },
    mainHeroBanner: {
        position: 'relative',
        width: '100%',
    },
    mainListBlock: {
        position: 'absolute',
        top: 35,
        left: 100,
    },
    accordian: {
        margin: '0px !important',
        '& svg': {
            color: theme.palette.cms?.white || '#fff',
            width: 20,
        },
    },
    summary: {
        '& div': {
            margin: '0px !important',
            flexGrow: 'inherit',
            padding: 0,
        },
        background: theme.palette.cms?.categoryBackground || '#931614',
    },
    accordianHeading: {
        margin: 0,
        color: theme.palette.cms?.white || '#fff',
        fontWeight: 'bold',
        textTransform: 'uppercase',
    },
    accordianDetails: {
        padding: 0,
    },

});

// List View
const ListData = (classes, list, listFontStyle) => {
    const seed = useUIDSeed();
    return (
        <div className={classes.listBlock}>
            <ul>
                {list?.link?.map((item) => (
                    <Link className={classes.link} key={seed(item)} style={listFontStyle} href={item?.href}>
                        <li>
                            {item?.title}
                        </li>
                    </Link>
                ))}
            </ul>
        </div>
    );
};

// Hero Banner Grid
const heroBlock = (classes, position, href, title, url, heading, sub_heading, button_copy, buttonStyleOverridess, headerStyle, subHeaderStyle, borderStyle) => (
    <Grid item xs={12} className={classes.imocBanner}>
        {href ?  (
            <Link href={href}>
                <img src={url} alt={title} className={classes.heroMainImage} />
            </Link>
        )
            : <img src={url} alt={title} className={classes.heroMainImage} />}
        <div className={classes.headerBlock} style={position}>
            <div style={borderStyle}>
                <div style={headerStyle}><ReactMarkdown source={heading} className={classes.heading} /></div>
                <div style={subHeaderStyle}> <ReactMarkdown source={sub_heading} className={classes.subHeading} /></div>
                { button_copy &&  <div className={classes.shopButton} style={buttonStyleOverridess}><Link href={href}>{button_copy}</Link></div>}
            </div>
        </div>
    </Grid>
);

const MobileHero = ({ classes, data, fontFamily }) => {
    const [expandedData, setExpand] = useState(true);
    const position = {};
    if (data) {
        const  buttonPosition  = data?.mobile_heading_alignment === 'right' ? 'flex-end' :   data?.mobile_heading_alignment || 'center';
        if (buttonPosition) {
            position.justifyContent = buttonPosition;
            position.bottom =  data?.mobile_heading_alignment === 'center' && 'auto';
            position.top =  data?.mobile_heading_alignment === 'center' && 15;
        }
    }
    const linkList = data?.link_list;
    // CMS Mobile style override
    const mobileStyleOverride = (backgroundColor = '', color = '', fonts = '', borderInPx) => ({
        backgroundColor: backgroundColor || '',
        color: color || '',
        fontFamily: fonts || '',
        border: `${borderInPx}px solid #F1B858` || '',
    });
    const buttonStyleOverrides = mobileStyleOverride(data?.button_background_color,  data?.button_font_color);
    const listFontStyle =  mobileStyleOverride('', linkList?.font_color?.color, fontFamily(linkList?.font_family));
    const headerStyle = mobileStyleOverride('',  data?.heading_font_color?.color,  fontFamily(data?.heading_font_family));
    const subHeaderStyle = mobileStyleOverride('',  data?.sub_heading_font_color?.color,  fontFamily(data?.sub_heading_font_family));
    const borderStyle =  mobileStyleOverride('',  '',  '', data?.border_width);
    return (
        <div className={classes.mainHeroBanner}>
            <div className={classes.mainImageBanner}>
                { heroBlock(classes, position, data?.link?.href, data?.link?.title, data?.mobile_image?.url, data?.mobile_heading, data?.mobile_sub_heading, data?.button_copy, buttonStyleOverrides, headerStyle, subHeaderStyle, borderStyle)}
            </div>
            {linkList?.link?.length > 0
            && (
                <Accordion className={classes.accordian}>
                    <AccordionSummary
                        style={{ backgroundColor: linkList?.font_color_hover?.color }}
                        className={classes.summary}
                        expandIcon={expandedData ? <Add />  : <Remove />}
                        aria-controls="panelcontent"
                        id="panelheader"
                        onClick={() => setExpand(!expandedData)}
                    >
                        <p className={classes.accordianHeading}>Categories</p>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordianDetails}>
                        {ListData(classes, linkList, listFontStyle)}
                    </AccordionDetails>
                </Accordion>
            )            }
        </div>
    );
};

MobileHero.propTypes = {
    classes: object.isRequired,
    data: shape({
        mobile_heading: string.isRequired,
        mobile_sub_heading: string.isRequired,
        mobile_image: shape({
            url: string.isRequired,
        }.isRequired),
        link: shape({
            href: string.isRequired,
        }.isRequired),
    }).isRequired,
    fontFamily: func.isRequired,
};

export default withStyles(styles)(MobileHero);
